import React, { Suspense, useContext, useEffect, useState } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import Button from "../../components/core/EPL_Button_Think";
import ErrorModal from "../../modals/ErrorModal";
// import useMediaQuery from '../../shared/hooks/useMediaQuery';
import useMediaQuery from "../../hooks/useMediaQuery";
// import VendorService from '../../shared/services/VendorService';
// import poll from '../../shared/utils/poll';
// import sendRequest from '../../shared/utils/sendRequest';
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import sendRequest from "../../utils/sendRequest";
// import { filterAddress, isValidAddress } from '../../shared/validations/Address';
// import { isValidCity } from '../../shared/validations/City';
// import { isValidPincode } from '../../shared/validations/Pincode';
// import Progress from '../progress/Progress';
// import Summary from '../summary/Summary';
import { useLocation } from "react-router-dom";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import appendRupee from "../../utils/appendRupee";
import { encrypt } from "../../utils/crypto";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
// import referenceArt from "../../assets/svg/EPL_think_svg/Reference_art.svg";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import { REVIEW_IPO } from "../../Config";
import SubTitle from "../../components/core/SubTitle";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { StyleWrapper } from "./_styles/StyleWrapper";
import { updateLead } from "../../shared/services/crm";
import {
  ZumigoFailed,
  ForeclosureChargesModal,
} from "../other-pages/Modals/AllModal";
import CheckField from "../../components/form/CheckField";
import EmandateIframeModal from "../../modals/EmandateIframeModal";
import IframeWithZoom from "../../components/advance/IFrame/IframeWithZoom";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import { encryptedData } from "../../utils/index.js";
import { userConsentStatus } from "../../utils/userConsentStatus";
import FallbackLoader from "../../components/FallbackLoader.js";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const PdfModal = React.lazy(() => import('../../modals/PdfModal.js'))

const ReviewDetails = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const [modal, setModal] = useState("");
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(true);
  const [interestRate, setInterestRate] = useState(12);
  const [roiApprovedEMI, setROIApprovedEMI] = useState(10); //constant.ROI_EMI.value);
  // const [roiApprovedEMI, setROIApprovedEMI] = useState((constant) => constant.ROI_EMI.value || 0);
  const [maxApprovedLoanAmount, setMaxApprovedLoanAmount] = useState(1000000); // constant.MAX_LOAN_AMT.value);
  const insuranceAmount = 1500;
  const [approvedRoi, setApprovedRoi] = useState("00");
  const [maxTenure, setMaxTenure] = useState("00"); // constant.MAX_TENURE.value);
  const minLoanIPOAmount = Number(20); // constant.MIN_LOAN_AMT.value);
  const minProcessingFee = Number(200); // constant.MIN_PROCESSING_FEE.value);
  const [minTenure, setMinTenure] = useState("00"); // constant.MIN_TENURE.value);
  const processingFeeROI = Number(10); // constant.ROI_PROCESSING_FEE.value);
  const [selectedLoanAmount, setSelectedLoanAmount] = useState("400000");
  const [approvedLoanAmount, setApprovedLoanAmount] = useState("000000");
  const [pf, setPf] = useState("0000");
  const [maxEmi, setMaxEmi] = useState("00000");
  const [emi, setEmi] = useState("00000");
  const [applicationFormNumber, setApplicationFormNumber] = useState([
    "EPL000000123",
  ]);
  const [tenure, setTenure] = useState("00");
  const [lastSelectedLoanAmount, setLastSelectedLoanAmount] =
    useState("000000");
  const [fetchData, setFetchedData] = useState(false);
  const [maxApprovedEMIAmount, setMaxApprovedEMIAmount] =
    useState(2000000000000);
  const [processingFee, setProcessingFee] = useState(0);
  const [ischecked, setIsChecked] = useState(false);
  const [viewBreakup, setViewBreakup] = useState(false);
  const [totalCharges, setTotalCharges] = useState(0);
  const [zumigoFailed, setZumigoFailed] = useState(false);
  const [foreclosureAmountFail, setForeclosureAmountFail] = useState(false);
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [showShimmer, setShowShimmer] = useState(true);
  const [dataCaptured, setDataCaptured] = useState();
  const [internetCheck, setInternetCheck] = useState(false);
  const [insuranceCheckBox, setInsuranceCheckBox] = useState(true);
  const [showKnowMoreModal, setShowKnowMoreModal] = useState();
  const [Insurance, setInsurance] = useState(0);
  const [base64Content, setBase64Content] = useState("");
  const [iFrameUrl, setiFrameUrl] = useState('');
  const [tncDoc, setTncDoc] = useState("");
  const [tncIframeModal, setTncIframeModal] = useState(false);

  useEffect(() => {
    isStageLogin(
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    setTncDoc(`${customerDetails?.Data?.tncPdf}`);
  }, []);

  useEffect(() => {
    // console.log("USECONTEXT>>>>>>>>>>>>>", customerDetails);
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("ReviewPage customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      // console.log(customerDetails.Data.foreclosure_amount);
      if (customerDetails.source === "upsell") {
        if (
          customerDetails?.Data?.foreclosure_amount === "None" ||
          customerDetails?.Data?.foreclosure_amount === null
        ) {
          setForeclosureAmountFail(true);
        }
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    } else {
      // console.log("ReviewPage Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  //   useEffect(async() => {
  //     // window.scrollTo(0, 0);
  //     // const dummyTimeout = setTimeout(() => {
  //     //   setShowShimmer(false);
  //     // }, 2000);
  //     // return () => clearTimeout(dummyTimeout);
  //     console.log("USEEFFECT")
  //     await GetCustomerDetails(customerDetails.application_form_number, customerDetails.source, customerDetails, setCustomerDetails);
  //     setDataCaptured();
  //   }, []);

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, [dataCaptured]);

  const handleCheckBox = async () => {
    setIsChecked(!ischecked);
    // console.log("checkBox clicked");
  };

  //   useEffect(() => {
  //     if (
  //       ![undefined, null].includes(customerDetails) &&
  //       customerDetails["changeAmount"]
  //     ) {
  //       navigate("/" + customerDetails.source + "/ipo", {
  //         replace: true,
  //         state: {
  //           customerDetails: customerDetails,
  //         },
  //       });
  //     }
  //   }, [customerDetails]);

  useEffect(() => {
    setTotalCharges(parseInt(customerDetails?.Data?.processing_fees_amount));
    setInsurance(
      parseFloat(customerDetails?.Data?.emi_protect_ins) +
      parseFloat(customerDetails?.Data?.accident_coverage_ins)
    );
  }, [customerDetails]);

  useEffect(() => {
    moengage.track_event("Review Insurance", {
      opted_for_insurance: insuranceCheckBox ? "YES" : "NO",
      "journey name": customerDetails.source,
      insurance_premium: Math.round(parseFloat(customerDetails?.Data?.emi_protect_ins) + parseFloat(customerDetails?.Data?.accident_coverage_ins))
    });
  }, [insuranceCheckBox])

  const changeAmount = async () => {
    let custInsChoice = "NO";
    if (insuranceCheckBox) {
      custInsChoice = "YES";
    }
    const formData = new FormData();
    const requestData = {
      current_stage: customerDetails.stage,
      stage_conditions: {
        amountChanged: true,
      },
    };
    formData.append("data", encryptedData(requestData));
    try {
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + REVIEW_IPO,
        formData
      );
      setShowShimmer(false);
      // console.log("INSERT_IPO response: ", response);
      if (response.response.Success === true) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            60,
            customerDetails.application_form_number
          );
        }
        // console.log(response.response.STAGE);
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        console.error(`EMI Check Failed!`);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          73,
          customerDetails.application_form_number
        );
      }
      setShowShimmer(false);
      console.error(`Unknown Error: ${error}`);
    }
  };

  const toggleViewBreakup = () => {
    setViewBreakup(!viewBreakup);
  };

  const reviewLoanIPO = async () => {
    try {
      // navigate("/loan", {
      // 	replace: true,
      // 	state: {
      // 		customerDetails: customerDetails,
      // 		// application_form_number: customerDetails.application_form_number
      // 	},
      // });

      let custInsChoice = "NO";
      if (insuranceCheckBox) {
        custInsChoice = "YES";
      }
      moengage.track_event("Review loan amount", {
        "final loan amount": customerDetails?.Data?.cust_accepted_loan_amount,
        "journey name": customerDetails.source,
      });
      const formData = new FormData();
      const requestData = {
        current_stage: customerDetails.stage,
        cust_ins_choice: custInsChoice,
        stage_conditions: {
          amountChanged: false,
        },
      };
      formData.append("data", encryptedData(requestData));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + REVIEW_IPO,
          formData
        );
        setShowShimmer(false);
        // console.log("INSERT_IPO response: ", response);
        if (response.response.Success === true) {
          if (customerDetails.source === "epl") {
            if (customerDetails?.Data?.zumigo_flag === "YES") {
              setCustomerDetails({
                ...customerDetails,
                stage: response.response.STAGE,
              });
            } else {
              setZumigoFailed(true);
            }
          } else if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              61,
              customerDetails.application_form_number
            );
            setCustomerDetails({
              ...customerDetails,
              stage: response.response.STAGE,
            });
          } else {
            setCustomerDetails({
              ...customerDetails,
              stage: response.response.STAGE,
            });
            updateLead(customerDetails.source, 102, customerDetails.application_form_number)
          }
          // if (customerDetails?.changeAmount === true) {
          // 	navigate("/review", {
          // 		replace: true,
          // 		state: {
          // 			customerDetails: customerDetails,
          // 			// application_form_number: customerDetails.application_form_number
          // 		},
          // 	});
          // }
          // console.log(response.response.STAGE);
          // navigate("/selfie", {
          //   replace: true,
          //   state: {
          //     customerDetails: customerDetails,
          //     // application_form_number: customerDetails.application_form_number
          //   },
          // });
        } else {
          console.error(`EMI Check Failed!`);
        }
      } catch (error) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            73,
            customerDetails.application_form_number
          );
        }
        setShowShimmer(false);
        console.error(`Unknown Error: ${error}`);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          73,
          customerDetails.application_form_number
        );
      }
      setShowShimmer(false);
      // console.log(error);
    }
  };

  const maskData = (data) => {
    if ([undefined, null, "None", ""].includes(data)) {
      return "None";
    }
    var maskedData = "";
    for (var i = 0; i < data.length; i++) {
      if (i < data.length - 4) {
        maskedData += "*";
      } else {
        maskedData += data[i];
      }
    }
    return maskedData;
  };

  function downloadPDF(pdfData, pdfFileName) {
    // // console.log("Downloading ", pdfFileName);
    // // console.log("pdfData ", pdfData);
    const linkSource = pdfData;
    // // console.log("linkSource ", linkSource);
    const downloadLink = document.createElement("a");
    const fileName = pdfFileName + ".pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    // // console.log("Downloaded ", pdfFileName);
  }

  const openPDFiFrame = () => {
    var fileName = "Insurance TnC";
    downloadPDF(tncDoc, fileName);
  }

  const handleProceed = () => {
    // Check if the TNC URL is valid before setting it
    if (
      insuranceCheckBox &&
      tncDoc &&
      typeof tncDoc === "string" &&
      tncDoc.trim() !== ""
    ) {
      setTncIframeModal(true);
    } else {
      reviewLoanIPO();
    }
  };

  const handleOkClick = async () => {
    const payload = {
      insurance_acceptance_of_tnc: insuranceCheckBox,
    }
    const src = customerDetails.source;

    await userConsentStatus(payload, src);
    await reviewLoanIPO();
  }

  return (
    <>
      <ProgressBar showProgress={true} currentStep={6} />
      <Suspense fallback={<FallbackLoader />}>
        {tncIframeModal && (
          <PdfModal
            isOpen={tncIframeModal}
            url={tncDoc}
            okButtonText="Agree"
            onOk={handleOkClick}
            showSecondButton={true}
            onSecondButtonClick={() => {
              setTncIframeModal(false)
              setInsuranceCheckBox(false)
            }}
          />
        )}
      </Suspense>
      <ZumigoFailed
        isOpen={zumigoFailed}
        onClose={() => {
          setZumigoFailed(false);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }}
      />
      <ForeclosureChargesModal
        isOpen={foreclosureAmountFail}
        onClose={() => {
          setForeclosureAmountFail(false);
          const currentURL = window.location.href;
          const lastSlashIndex = currentURL.lastIndexOf("/");
          const resultURL = currentURL.slice(0, lastSlashIndex);
          window.location.replace(resultURL + "/login");
        }}
      />
      <AfterLoginLayoutWrapper width={"100%"}>
        <Loading
          open={modal === "LOADING_CKYC"}
          msg="Please wait while we verify your details."
        />
        <Loading open={modal === "LOADING"} />
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <StyleWrapper>
          <ShimmerPlaceholder
            height="2.5em"
            width="15em"
            marginTop="1em"
            visible={showShimmer}
          />
          <Title
            id="pageTitle"
            className="pageTitle"
            text={`Review your Loan Plan`}
            visible={!showShimmer}
            clickable={false}
          />
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                height="12em"
                width="25em"
                marginTop="1em"
                visible={showShimmer}
              />
              <ShimmerPlaceholder
                height="14em"
                width="25em"
                marginTop="2em"
                visible={showShimmer}
              />
            </>
          ) : (
            <>
              <div className="review-box">
                <div className="review-row">
                  <div className="review-title">Loan Amount</div>
                  <div className="review-value">
                    {appendRupee(
                      customerDetails?.Data?.cust_accepted_loan_amount || "0"
                    )}
                  </div>
                </div>
                {/* <div className="review-row flex-end">
              <div className="review-title"></div>
              <button className="review-button" onClick={changeAmount}>
                Change Amount
              </button>
            </div> */}
                <div className="review-row">
                  <div className="review-title">Charges</div>
                  <div className="review-value">
                    (-){" "}
                    {appendRupee(
                      Math.round(
                        insuranceCheckBox
                          ? totalCharges + Insurance
                          : totalCharges
                      )
                    )}
                  </div>
                </div>
                <div
                  className="review-row"
                  style={{ fontSize: "larger", fontWeight: "bold" }}
                >
                  <div className="insurance-checkbox">
                    <CheckField
                      id="basic-ckeckfield"
                      checked={insuranceCheckBox}
                      label=""
                      style={{
                        fontSize: "15px",
                        marginLeft: "15px",
                      }}
                      onClick={() => {
                        setInsuranceCheckBox(!insuranceCheckBox);
                      }}
                    />
                    <div className=" review-title insurance-field">
                      Insurance
                    </div>
                  </div>
                  <div
                    className="review-value"
                    style={{ fontSize: "large", fontWeight: "bold" }}
                  >
                    {appendRupee(Math.round(Insurance))}
                  </div>
                </div>
                <div className="review-row flex-end">
                  <div>
                    <button
                      className="review-button"
                      style={{ marginLeft: "27px" }}
                      onClick={() => openPDFiFrame("KFS")}
                    >
                      Know More
                    </button>
                  </div>
                  <button className="review-button" onClick={toggleViewBreakup}>
                    {viewBreakup ? "Hide Breakup" : "View Breakup"}
                  </button>
                </div>
                {viewBreakup ? (
                  <>
                    <div className="review-row">
                      <div className="review-title">Processing Fees</div>
                      <div className="review-value">
                        (-){" "}
                        {appendRupee(
                          customerDetails?.Data?.processing_fees_amount || "0"
                        )}
                      </div>
                    </div>
                    {insuranceCheckBox ? (
                      <div className="review-row">
                        <div className="review-title">Insurance Amount</div>
                        <div className="review-value">
                          (-) {appendRupee(Math.round(Insurance) || "0")}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    {/* {customerDetails?.source === "upsell" ? (
                      <div className="review-row">
                        <div className="review-title">
                          Interest Closure Charges
                        </div>
                        <div className="review-value">
                          (-){" "}
                          {appendRupee(
                            customerDetails?.Data?.foreclosure_amount
                          )}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )} */}
                  </>
                ) : (
                  <></>
                )}
                <div className="colored-box">
                  <div className="review-row">
                    <div className="review-title colored-text">
                      Final Amount
                    </div>
                    <div className="review-value colored-text">
                      {insuranceCheckBox
                        ? appendRupee(
                          (customerDetails?.Data?.cust_accepted_loan_amount ||
                            0) -
                          totalCharges -
                          Math.round(Insurance)
                        )
                        : appendRupee(
                          (customerDetails?.Data?.cust_accepted_loan_amount ||
                            0) - totalCharges
                        )}
                    </div>
                  </div>
                  <div className="review-row flex-start">
                    <div className="review-title">
                      Will be transferred to the bank account
                    </div>
                  </div>
                  {/* <div className="review-row flex-start">
                    <Button
                      id="Btn"
                      className="Btn"
                      mobile={isMobile}
                      disabled={false}
                      text={"Change Amount"}
                      style={{
                        marginTop: "10px",
                      }}
                      onClick={changeAmount}
                    />
                  </div> */}
                </div>
              </div>
              <div className="review-bottom-behind-box">
                <div className="review-data-box">
                  <div className="review-block">
                    <div className="review-title">Monthly Installment</div>
                    <div className="review-value">
                      {appendRupee(
                        customerDetails?.Data?.cust_accepted_emi || 0
                      )}
                    </div>
                    <div className="review-message">
                      5<sup>th</sup> of every month
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Interest Rate</div>
                    <div className="review-value">
                      {(customerDetails?.Data?.roi || 0) + "% p.a."}
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Tenure</div>
                    <div className="review-value">
                      {(customerDetails?.Data?.tenure || 0) + " Months"}
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Bank Account</div>
                    <div className="review-value">
                      {maskData(customerDetails?.Data?.account_number) ||
                        "None"}
                    </div>
                  </div>
                  <div className="review-block">
                    <div className="review-title">Annual Percentage Rate</div>
                    <div className="review-value">{insuranceCheckBox?(customerDetails?.Data?.with_ins):(customerDetails?.Data?.without_ins)} % p.a.</div>
                  </div>
                </div>
                <div className="review-block bottom">
                  {/* <div className="review-message">
                    * Will be available after 6<sup>th</sup> EMI Payment
                  </div> */}
                </div>
              </div>
            </>
          )}

          <div className="bottomDiv only-btn">
            {showShimmer ? (
              <>
                {/* <ShimmerPlaceholder
                  height="3em"
                  width="25em"
                  marginTop="-0.5em"
                  visible={showShimmer}
                /> */}
                <ShimmerPlaceholder
                  height="2.5em"
                  width="10em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                {/* <SubTitle
                  id="pageSubTitle"
                  className="pageSubTitle"
                  text={
                    "I acknowledged that I have read, and do hereby accept the terms and conditions contained in the loan agreement."
                  }
                  visible={true}
                  clickable={false}
                  style={{ fontSize: "1.2rem" }}
                /> */}
                <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  disabled={false}
                  text={"Proceed"}
                  onClick={handleProceed}
                // 	() => {
                // 		navigate("/bank-details", {
                // 		replace: true,
                // 		state: {
                // 			customerDetails: customerDetails,
                // 		},
                // 	});
                // }}
                />
              </>
            )}
          </div>
        </StyleWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default ReviewDetails;
